import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './FieldError.css'

/**
 * Field Error displays validation error text for a [Field](/components/field/).
 * It is styled to match the error text used by Nord form controls such as
 * [Input](/components/input/).
 *
 * Exposes itself as a live region (`role="alert"`, `aria-live="polite"`) so the
 * message is announced when it appears. The message is supplied as the
 * element's children.
 *
 * @status draft
 * @category form
 * @lightDom true
 *
 * @slot - Default slot for the error message(s).
 */
@customElement('nord-field-error')
export default class FieldError extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)

    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'alert')
    }
    if (!this.hasAttribute('aria-live')) {
      this.setAttribute('aria-live', 'polite')
    }
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-field-error': FieldError
  }
}
